export const SET_HEYCAR_BRAND = 'heycarpromotion//SET_HEYCAR_BRAND';
export const SET_HEYCAR_MANUFACTURER =
  'heycarpromotion//SET_HEYCAR_MANUFACTURER';
export const SET_HEYCAR_MANUAL_BRAND_SELECTION =
  'heycarpromotion//SET_HEYCAR_MANUAL_BRAND_SELECTION';

export function geHeycarBrand(state) {
  return state.heycarpromotion.brand;
}

export function setHeycarBrand(brand) {
  return {
    type: SET_HEYCAR_BRAND,
    payload: brand
  };
}

export function setHeycarManufacturer(brand) {
  return {
    type: SET_HEYCAR_MANUFACTURER,
    payload: brand
  };
}

const initialState = {
  brand: '',
  manufacturer: ''
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_HEYCAR_BRAND:
      return { ...state, brand: action.payload };
    case SET_HEYCAR_MANUFACTURER:
      return { ...state, manufacturer: action.payload };
    default:
      return state;
  }
}
